export default __webpack_public_path__ + "static/media/sc13.ad40d079.jpg";